import React from 'react';

import uuid from 'uuid';

import { StyledAds } from './style/StyledAds';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const Ads = ({ data, isLast }) => (
	<StyledAds key={uuid.v4()}>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			(data.tables.length > 0) ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.tables.map(table => <DynamicComponent key={uuid.v4()} tag={table.type} keys={table.keys} data={table.data} typeChart="CampaignRange" />)}
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr className="mt-4" /> : null}
	</StyledAds>
);

export default Ads;
